import { useEffect, useContext } from 'react';
import { isNameInUse, registerName, unregisterName, areThereMultipleTabStrips } from 'utils/TabStrip';
import TabStripContext from 'contexts/TabStripContext';

const localStorageKey = 'TS_NAMES';

const useTabStripRegistration = ({ identifier, className } = { identifier: '', className: '' }) => {
  const {
    registrationError,
    setRegistrationError,
  } = useContext(TabStripContext);

  useEffect(() => {
    if (areThereMultipleTabStrips(className)) {
      if (!isNameInUse(localStorageKey, identifier)) {
        // Multiple instances but my identifier is not duplicated
        registerName(localStorageKey, identifier);
      }
    } else {
      // Only my instance, so we check that we havent register our name already
      registerName(localStorageKey, identifier);
    }

    window.addEventListener('beforeunload', () => unregisterName(localStorageKey, identifier));

    return () => {
      window.removeEventListener('beforeunload', () => unregisterName(localStorageKey, identifier));
    };
  }, [identifier, className, setRegistrationError]);

  return { registrationError };
};

export default useTabStripRegistration;
